/**
 * Math&Sport Authentication API
 * POST /api/auth/ → Bearer token
 * Il token viene riutilizzato anche per le chiamate all'hub Serie A B2B.
 */

const MS_BASE_URL = (
  process.env.REACT_APP_MS_API_BASE_URL || 'https://football.mathandsport.com'
).replace(/\/$/, '');

let _token = null;

export async function login(username, password) {
  let response;
  try {
    response = await fetch(`${MS_BASE_URL}/api/auth/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });
  } catch (networkErr) {
    throw new Error(`Errore di rete durante il login: ${networkErr.message}. Verifica la connessione o problemi CORS.`);
  }

  if (!response.ok) {
    let body = '';
    try { body = await response.text(); } catch {}
    throw new Error(`Login fallito (${response.status})${body ? ': ' + body.slice(0, 150) : '. Controlla username e password.'}`);
  }

  let data;
  try {
    data = await response.json();
  } catch {
    throw new Error('Risposta di autenticazione non valida (non JSON)');
  }

  // Il token può essere in campi diversi a seconda della versione API
  _token = data.token || data.access_token || data.key || data.accessToken || null;

  if (!_token) {
    // Se la risposta è una stringa semplice
    if (typeof data === 'string' && data.length > 10) {
      _token = data;
    } else {
      console.warn('[Auth] Struttura risposta:', JSON.stringify(data).slice(0, 200));
      throw new Error('Token non trovato nella risposta. Struttura inattesa.');
    }
  }

  if (process.env.NODE_ENV === 'development') {
    console.log('[Auth] Login OK, token ricevuto:', _token.slice(0, 20) + '...');
  }

  return _token;
}

export function getToken() { return _token; }
export function clearToken() { _token = null; }
export function isAuthenticated() { return Boolean(_token); }

/**
 * Partite dall'API Math&Sport (diversa dall'hub Serie A)
 */
export async function getMSMatches({ matchdayStart, matchdayEnd, season = '2025/2026' } = {}) {
  if (!_token) throw new Error('Non autenticato');

  const url = new URL(`${MS_BASE_URL}/api/matches/`);
  if (matchdayStart != null) url.searchParams.set('matchday_start', matchdayStart);
  if (matchdayEnd != null) url.searchParams.set('matchday_end', matchdayEnd);
  url.searchParams.set('season', season);

  const response = await fetch(url.toString(), {
    headers: { Authorization: `Bearer ${_token}` },
  });

  if (!response.ok) throw new Error(`Errore partite M&S: ${response.status}`);
  return response.json();
}
